import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { Directory } from '@app/shared/models/employee/documents/directory.model';
import { DocumentUpdate } from '../../models/document.model';
import { EmployeeDocumentsService } from '../../services/employee-documents.service';

@Component({
  selector: 'app-edit-document-dialog',
  templateUrl: './edit-document-dialog.component.html',
  styleUrls: ['./edit-document-dialog.component.scss']
})
export class EditDocumentDialogComponent implements OnInit {
  document: Directory;
  newName: string;
  employeeId: string;

  constructor(
    private snackbarService: SnackbarService,
    private employeeDocumentsService: EmployeeDocumentsService,
    private dialogRef: MatDialogRef<EditDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.employeeId = data.employeeId;
      this.document = data.document;
      this.newName = this.document.name;
  }

  ngOnInit(): void {
  }

  save() {
    const updateDetails: DocumentUpdate = {
      parent: this.document.parent,
      comments: '',
      name: this.newName
    }

    this.employeeDocumentsService.updateDocument(this.employeeId, this.document.id, updateDetails)
    .subscribe(
      (res) => {
        this.dialogRef.close(true);
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  close() {
    this.dialogRef.close();
  }

}
